import React, { FC, useCallback } from 'react'
import { useEditorModel } from '../../useEditorModel'
import { useTranslation } from 'react-i18next'
import { validateDate } from '@linqpal/models/src/helpers/validations'
import { Spacer } from '../../../../../ui/atoms'
import { CompProps } from '../../Editor'
import { BtDateInput } from '@linqpal/components/src/ui'

export const BirthdateInput: FC<CompProps & { testID: string }> = ({
  doc,
  item,
  group,
  review,
  onValueUpdate,
  testID,
}) => {
  const { t } = useTranslation('application')

  const validate = useCallback(
    (value: string | null) => !!value && validateDate(value, 1900),
    [],
  )

  const model = useEditorModel(doc, group, item, onValueUpdate, '', validate)

  const validateInput = (value: string) =>
    value.length !== 10 || validateDate(value, 1900)
      ? ''
      : t('ValidationErrors.InvalidDate')

  const handleChangeText = (value: string) => {
    model.setValue('value', value)
  }

  return (
    <>
      <Spacer height={review ? 24 : 18} />
      <BtDateInput
        size="large"
        //eslint-disable-next-line i18next/no-literal-string
        format="MM/DD/YYYY"
        value={model.value}
        validate={validateInput}
        testID={testID}
        label={t('Owner.BirthdayLabel')}
        onChangeText={handleChangeText}
      />
    </>
  )
}
